// MIMIR character mark — typographic, NOT a mascot. A serif italic "m" on a
// sage-circle background. Size scales the inner glyph at 0.5× for visual
// balance, matching the prototype.
//
// Ported from handoff_input/design/screens/shared.jsx :: ICSMimirMark.

import type { CSSProperties } from "react";
import { cn } from "@/lib/utils";

export interface MimirMarkProps {
  /** Diameter in px. Inner italic-m sizes proportionally. Default 28 px
   *  matches the prototype's most common usage in chat bubbles. */
  size?: number;
  className?: string;
}

export function MimirMark({ size = 28, className }: MimirMarkProps) {
  const wrapperStyle: CSSProperties = {
    width: size,
    height: size,
  };
  const glyphStyle: CSSProperties = {
    fontSize: size * 0.5,
  };
  return (
    <div
      aria-hidden="true"
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full",
        "bg-paper-muted text-ink",
        className,
      )}
      style={wrapperStyle}
    >
      <span
        className="font-serif italic font-medium leading-none"
        style={glyphStyle}
      >
        m
      </span>
    </div>
  );
}
